export default __webpack_public_path__ + "static/media/0156.e1e6cb5d.png";